/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../../types/schema.generated';

import gql from 'graphql-tag';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type ReactiveFunction<TParam> = () => TParam;
export type ChatMessageAttachmentType =
  /** 日程調整 */
  | 'BOOKING_REQUEST';

export type ChatRoomStatus =
  /** 要対応(OA向けに作ったものだが、一般にも使えるようなenumにする) */
  | 'ActionRequired'
  /** 面談済み・対応中 */
  | 'Appointed'
  /** 対応不要 */
  | 'Archived'
  /** 契約済み */
  | 'ContractConcluded'
  /** 保険契約済み */
  | 'ContractConcludedInsurance'
  /** 証券契約済み */
  | 'ContractConcludedSecurities'
  /** 不満足の表明(OA向けに作ったものだが、一般にも使えるようなenumにする) */
  | 'GotComplaints'
  /** 後追い対応 */
  | 'Keeping'
  /** 失注 */
  | 'LostOrder'
  /** チャット対応中 */
  | 'Messaging'
  /** 未設定 */
  | 'NotDefined'
  /** 面談設定中 */
  | 'Offering'
  /** 初回面談実施待ち */
  | 'WaitingForFirstAppointment';

export type SendChatMessageAttachmentInput = {
  /** JSON 文字列 */
  rawContent: string;
  type: ChatMessageAttachmentType;
};

export type SendNormalChatMessageInput = {
  attachments: Array<SendChatMessageAttachmentInput>;
  chatRoomId: string | number;
  message: string;
  sendAsStaff?: boolean | null | undefined;
};

export type SendQuestionChatMessageInput = {
  answerSelections: Array<string>;
  chatRoomId: string | number;
  message: string;
  sendAsStaff?: boolean | null | undefined;
};

export type AddChatRoomMemoMutationVariables = Exact<{
  chatRoomID: string | number;
  content: string;
}>;


export type AddChatRoomMemoMutation = { addChatRoomMemo: { id: string, memos: Array<{ id: string, content: string, createdAt: TimeString }> } };

export type DeleteChatRoomMemoMutationVariables = Exact<{
  id: string | number;
}>;


export type DeleteChatRoomMemoMutation = { deleteChatRoomMemo: { id: string, memos: Array<{ id: string, content: string, createdAt: TimeString }> } };

export type UpdateStatusMutationVariables = Exact<{
  id: string | number;
  status: Types.ChatRoomStatus;
}>;


export type UpdateStatusMutation = { updateStatus: { id: string, status: Types.ChatRoomStatus } | null };

export type ChatPageOwnViewPreviewNormalChatMessageQueryVariables = Exact<{
  input: Types.SendNormalChatMessageInput;
}>;


export type ChatPageOwnViewPreviewNormalChatMessageQuery = { previewNormalChatMessage: { maybeOtherUserNames: Array<string>, preview: { message: string } } };

export type ChatPageOwnViewPreviewQuestionChatMessageQueryVariables = Exact<{
  input: Types.SendQuestionChatMessageInput;
}>;


export type ChatPageOwnViewPreviewQuestionChatMessageQuery = { previewQuestionChatMessage: { maybeOtherUserNames: Array<string>, preview: { message: string } } };

export type ChatPageOwnViewReviewQueryVariables = Exact<{
  userId: string | number;
}>;


export type ChatPageOwnViewReviewQuery = { review: { id: string } | null };


export const AddChatRoomMemoDocument = gql`
    mutation addChatRoomMemo($chatRoomID: ID!, $content: String!) {
  addChatRoomMemo(chatRoomID: $chatRoomID, content: $content) {
    id
    memos {
      id
      content
      createdAt
    }
  }
}
    `;

/**
 * __useAddChatRoomMemoMutation__
 *
 * To run a mutation, you first call `useAddChatRoomMemoMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddChatRoomMemoMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddChatRoomMemoMutation({
 *   variables: {
 *     chatRoomID: // value for 'chatRoomID'
 *     content: // value for 'content'
 *   },
 * });
 */
export function useAddChatRoomMemoMutation(options: VueApolloComposable.UseMutationOptions<AddChatRoomMemoMutation, AddChatRoomMemoMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<AddChatRoomMemoMutation, AddChatRoomMemoMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<AddChatRoomMemoMutation, AddChatRoomMemoMutationVariables>(AddChatRoomMemoDocument, options);
}
export type AddChatRoomMemoMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<AddChatRoomMemoMutation, AddChatRoomMemoMutationVariables>;
export const DeleteChatRoomMemoDocument = gql`
    mutation deleteChatRoomMemo($id: ID!) {
  deleteChatRoomMemo(chatRoomMemoID: $id) {
    id
    memos {
      id
      content
      createdAt
    }
  }
}
    `;

/**
 * __useDeleteChatRoomMemoMutation__
 *
 * To run a mutation, you first call `useDeleteChatRoomMemoMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteChatRoomMemoMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteChatRoomMemoMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteChatRoomMemoMutation(options: VueApolloComposable.UseMutationOptions<DeleteChatRoomMemoMutation, DeleteChatRoomMemoMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteChatRoomMemoMutation, DeleteChatRoomMemoMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteChatRoomMemoMutation, DeleteChatRoomMemoMutationVariables>(DeleteChatRoomMemoDocument, options);
}
export type DeleteChatRoomMemoMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteChatRoomMemoMutation, DeleteChatRoomMemoMutationVariables>;
export const UpdateStatusDocument = gql`
    mutation updateStatus($id: ID!, $status: ChatRoomStatus!) {
  updateStatus(id: $id, status: $status) {
    id
    status
  }
}
    `;

/**
 * __useUpdateStatusMutation__
 *
 * To run a mutation, you first call `useUpdateStatusMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStatusMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateStatusMutation({
 *   variables: {
 *     id: // value for 'id'
 *     status: // value for 'status'
 *   },
 * });
 */
export function useUpdateStatusMutation(options: VueApolloComposable.UseMutationOptions<UpdateStatusMutation, UpdateStatusMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateStatusMutation, UpdateStatusMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateStatusMutation, UpdateStatusMutationVariables>(UpdateStatusDocument, options);
}
export type UpdateStatusMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateStatusMutation, UpdateStatusMutationVariables>;
export const ChatPageOwnViewPreviewNormalChatMessageDocument = gql`
    query ChatPageOwnViewPreviewNormalChatMessage($input: SendNormalChatMessageInput!) {
  previewNormalChatMessage(input: $input) {
    preview {
      message
    }
    maybeOtherUserNames
  }
}
    `;

/**
 * __useChatPageOwnViewPreviewNormalChatMessageQuery__
 *
 * To run a query within a Vue component, call `useChatPageOwnViewPreviewNormalChatMessageQuery` and pass it any options that fit your needs.
 * When your component renders, `useChatPageOwnViewPreviewNormalChatMessageQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useChatPageOwnViewPreviewNormalChatMessageQuery({
 *   input: // value for 'input'
 * });
 */
export function useChatPageOwnViewPreviewNormalChatMessageQuery(variables: ChatPageOwnViewPreviewNormalChatMessageQueryVariables | VueCompositionApi.Ref<ChatPageOwnViewPreviewNormalChatMessageQueryVariables> | ReactiveFunction<ChatPageOwnViewPreviewNormalChatMessageQueryVariables>, options: VueApolloComposable.UseQueryOptions<ChatPageOwnViewPreviewNormalChatMessageQuery, ChatPageOwnViewPreviewNormalChatMessageQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ChatPageOwnViewPreviewNormalChatMessageQuery, ChatPageOwnViewPreviewNormalChatMessageQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ChatPageOwnViewPreviewNormalChatMessageQuery, ChatPageOwnViewPreviewNormalChatMessageQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ChatPageOwnViewPreviewNormalChatMessageQuery, ChatPageOwnViewPreviewNormalChatMessageQueryVariables>(ChatPageOwnViewPreviewNormalChatMessageDocument, variables, options);
}
export function useChatPageOwnViewPreviewNormalChatMessageLazyQuery(variables?: ChatPageOwnViewPreviewNormalChatMessageQueryVariables | VueCompositionApi.Ref<ChatPageOwnViewPreviewNormalChatMessageQueryVariables> | ReactiveFunction<ChatPageOwnViewPreviewNormalChatMessageQueryVariables>, options: VueApolloComposable.UseQueryOptions<ChatPageOwnViewPreviewNormalChatMessageQuery, ChatPageOwnViewPreviewNormalChatMessageQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ChatPageOwnViewPreviewNormalChatMessageQuery, ChatPageOwnViewPreviewNormalChatMessageQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ChatPageOwnViewPreviewNormalChatMessageQuery, ChatPageOwnViewPreviewNormalChatMessageQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ChatPageOwnViewPreviewNormalChatMessageQuery, ChatPageOwnViewPreviewNormalChatMessageQueryVariables>(ChatPageOwnViewPreviewNormalChatMessageDocument, variables, options);
}
export type ChatPageOwnViewPreviewNormalChatMessageQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ChatPageOwnViewPreviewNormalChatMessageQuery, ChatPageOwnViewPreviewNormalChatMessageQueryVariables>;
export const ChatPageOwnViewPreviewQuestionChatMessageDocument = gql`
    query ChatPageOwnViewPreviewQuestionChatMessage($input: SendQuestionChatMessageInput!) {
  previewQuestionChatMessage(input: $input) {
    preview {
      message
    }
    maybeOtherUserNames
  }
}
    `;

/**
 * __useChatPageOwnViewPreviewQuestionChatMessageQuery__
 *
 * To run a query within a Vue component, call `useChatPageOwnViewPreviewQuestionChatMessageQuery` and pass it any options that fit your needs.
 * When your component renders, `useChatPageOwnViewPreviewQuestionChatMessageQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useChatPageOwnViewPreviewQuestionChatMessageQuery({
 *   input: // value for 'input'
 * });
 */
export function useChatPageOwnViewPreviewQuestionChatMessageQuery(variables: ChatPageOwnViewPreviewQuestionChatMessageQueryVariables | VueCompositionApi.Ref<ChatPageOwnViewPreviewQuestionChatMessageQueryVariables> | ReactiveFunction<ChatPageOwnViewPreviewQuestionChatMessageQueryVariables>, options: VueApolloComposable.UseQueryOptions<ChatPageOwnViewPreviewQuestionChatMessageQuery, ChatPageOwnViewPreviewQuestionChatMessageQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ChatPageOwnViewPreviewQuestionChatMessageQuery, ChatPageOwnViewPreviewQuestionChatMessageQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ChatPageOwnViewPreviewQuestionChatMessageQuery, ChatPageOwnViewPreviewQuestionChatMessageQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ChatPageOwnViewPreviewQuestionChatMessageQuery, ChatPageOwnViewPreviewQuestionChatMessageQueryVariables>(ChatPageOwnViewPreviewQuestionChatMessageDocument, variables, options);
}
export function useChatPageOwnViewPreviewQuestionChatMessageLazyQuery(variables?: ChatPageOwnViewPreviewQuestionChatMessageQueryVariables | VueCompositionApi.Ref<ChatPageOwnViewPreviewQuestionChatMessageQueryVariables> | ReactiveFunction<ChatPageOwnViewPreviewQuestionChatMessageQueryVariables>, options: VueApolloComposable.UseQueryOptions<ChatPageOwnViewPreviewQuestionChatMessageQuery, ChatPageOwnViewPreviewQuestionChatMessageQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ChatPageOwnViewPreviewQuestionChatMessageQuery, ChatPageOwnViewPreviewQuestionChatMessageQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ChatPageOwnViewPreviewQuestionChatMessageQuery, ChatPageOwnViewPreviewQuestionChatMessageQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ChatPageOwnViewPreviewQuestionChatMessageQuery, ChatPageOwnViewPreviewQuestionChatMessageQueryVariables>(ChatPageOwnViewPreviewQuestionChatMessageDocument, variables, options);
}
export type ChatPageOwnViewPreviewQuestionChatMessageQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ChatPageOwnViewPreviewQuestionChatMessageQuery, ChatPageOwnViewPreviewQuestionChatMessageQueryVariables>;
export const ChatPageOwnViewReviewDocument = gql`
    query ChatPageOwnViewReview($userId: ID!) {
  review(userId: $userId) {
    id
  }
}
    `;

/**
 * __useChatPageOwnViewReviewQuery__
 *
 * To run a query within a Vue component, call `useChatPageOwnViewReviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useChatPageOwnViewReviewQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useChatPageOwnViewReviewQuery({
 *   userId: // value for 'userId'
 * });
 */
export function useChatPageOwnViewReviewQuery(variables: ChatPageOwnViewReviewQueryVariables | VueCompositionApi.Ref<ChatPageOwnViewReviewQueryVariables> | ReactiveFunction<ChatPageOwnViewReviewQueryVariables>, options: VueApolloComposable.UseQueryOptions<ChatPageOwnViewReviewQuery, ChatPageOwnViewReviewQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ChatPageOwnViewReviewQuery, ChatPageOwnViewReviewQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ChatPageOwnViewReviewQuery, ChatPageOwnViewReviewQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ChatPageOwnViewReviewQuery, ChatPageOwnViewReviewQueryVariables>(ChatPageOwnViewReviewDocument, variables, options);
}
export function useChatPageOwnViewReviewLazyQuery(variables?: ChatPageOwnViewReviewQueryVariables | VueCompositionApi.Ref<ChatPageOwnViewReviewQueryVariables> | ReactiveFunction<ChatPageOwnViewReviewQueryVariables>, options: VueApolloComposable.UseQueryOptions<ChatPageOwnViewReviewQuery, ChatPageOwnViewReviewQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ChatPageOwnViewReviewQuery, ChatPageOwnViewReviewQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ChatPageOwnViewReviewQuery, ChatPageOwnViewReviewQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ChatPageOwnViewReviewQuery, ChatPageOwnViewReviewQueryVariables>(ChatPageOwnViewReviewDocument, variables, options);
}
export type ChatPageOwnViewReviewQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ChatPageOwnViewReviewQuery, ChatPageOwnViewReviewQueryVariables>;